import React from 'react';
import './TooltipCard.scss';

interface TooltipCardProps {
    /** Content rendered inside the floating card. Pass null/undefined to disable the tooltip entirely. */
    content: React.ReactNode;
    /** The element that acts as the hover trigger. */
    children: React.ReactNode;
    /** Where the card appears relative to the trigger. Defaults to 'top'. */
    placement?: 'top' | 'bottom';
    /** Extra CSS class applied to the popup card (e.g. for width overrides). */
    cardClassName?: string;
}

/**
 * TooltipCard — wraps any element and shows a floating card on hover.
 *
 * Usage:
 *   <TooltipCard content={<span>Some info</span>}>
 *     <strong>Hover me</strong>
 *   </TooltipCard>
 *
 * When `content` is null or undefined, the children are rendered as-is (no tooltip markup).
 */
const TooltipCard: React.FC<TooltipCardProps> = ({
    content,
    children,
    placement = 'top',
    cardClassName,
}) => {
    if (!content) {
        // No tooltip — render children transparently
        return <>{children}</>;
    }

    return (
        <div className={`tooltip-card-wrapper tooltip-card-${placement}`}>
            {children}
            <div className={`tooltip-card-popup${cardClassName ? ` ${cardClassName}` : ''}`}>
                {content}
            </div>
        </div>
    );
};

export default TooltipCard;

